
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
 
export default new Vuex.Store({
  state:{
    gonggaoShow:true,//公告显示状态
    openEditionStatus:false,//开版显示状态
    concatUsStatus:false,//联系我们显示状态
  },
  mutations:{
    CHANGEGONGGAO(state, isClose){
      state.gonggaoShow = isClose
    },
    CHANGEOPENEDITIONSTATUS(state, value){
      state.openEditionStatus = value
    },
    CHANGECONCATUSSTATUS(state, value){
      state.concatUsStatus = value
    }
  },
  actions:{},
  getters:{}
})


// WEBPACK FOOTER //
// ./src/router/store.js